import React from 'react';

const newsData = [
  {
    date: '5/3/25',
    title: "We're Expanding to Southeast Asia",
    image: '/images/news1.jpg',
    link: '#'
  },
  {
    date: '5/3/25',
    title: "New Partner Joins the Team",
    image: '/images/news2.jpg',
    link: '#'
  },
  {
    date: '5/3/25',
    title: "2025 Investment Thesis: What We're Backing Next",
    image: '/images/news3.jpg',
    link: '#'
  },
  {
    date: '5/3/25',
    title: "The best tech bets begin with empathy",
    image: '/images/news4.jpg',
    link: '#'
  },
  {
    date: '5/3/25',
    title: "Market insight",
    image: '/images/news5.jpg',
    link: '#'
  },
  {
    date: '5/3/25',
    title: "Behind-the-scenes of Genix Event",
    image: '/images/news6.jpg',
    link: '#'
  }
];

const gridStyle = {
  display: 'grid',
  gridTemplateColumns: 'repeat(3, 1fr)',
  gap: 32,
  marginBottom: 40
};

const responsiveStyle = `
@media (max-width: 900px) {
  .resources-news-grid { grid-template-columns: repeat(2, 1fr) !important; }
}
@media (max-width: 600px) {
  .resources-news-grid { grid-template-columns: 1fr !important; }
}
`;

const ResourcesLatestNews = () => (
  <section style={{ maxWidth: 1200, margin: '64px auto 0 auto', padding: '0 24px' }}>
    <style>{responsiveStyle}</style>
    <hr style={{ border: 0, borderTop: '2px solid #cbd5e1', marginBottom: 24 }} />
    <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 32 }}>
      <span style={{ color: '#0098d0', fontWeight: 600, fontSize: 24, cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
        Latest News
        <svg style={{ marginLeft: 6 }} width="18" height="18" viewBox="0 0 24 24" fill="none">
          <path d="M7 10l5 5 5-5" stroke="#0098d0" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </span>
    </div>
    <div className="resources-news-grid" style={gridStyle}>
      {newsData.map((news, idx) => (
        <div
          key={idx}
          style={{
            position: 'relative',
            borderRadius: 18,
            overflow: 'hidden',
            minHeight: 200,
            background: `url(${news.image}) center/cover no-repeat`,
            color: '#fff',
            boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-end'
          }}
        >
          <div style={{
            position: 'absolute',
            top: 0, left: 0, right: 0, bottom: 0,
            background: 'linear-gradient(180deg, rgba(0,0,0,0.18) 40%, rgba(0,0,0,0.38) 100%)'
          }} />
          <div style={{ position: 'relative', zIndex: 2, padding: 24, height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'flex-end' }}>
            <div style={{ fontSize: 15, opacity: 0.85, marginBottom: 8 }}>{news.date}</div>
            <div style={{ fontWeight: 600, fontSize: 22, marginBottom: 18, lineHeight: 1.2 }}>{news.title}</div>
            <a
              href={news.link}
              style={{
                color: '#fff',
                fontWeight: 500,
                fontSize: 16,
                textDecoration: 'underline',
                opacity: 0.95,
                marginTop: 'auto'
              }}
            >
              Read more
            </a>
          </div>
        </div>
      ))}
    </div>
    <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 32 }}>
      <button
        style={{
          border: '2px solid #0098d0',
          background: 'transparent',
          color: '#0098d0',
          fontWeight: 500,
          fontSize: 18,
          borderRadius: 12,
          padding: '14px 48px',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: 10,
          transition: 'background 0.2s, color 0.2s'
        }}
      >
        load More
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
          <path d="M5 12h14M13 6l6 6-6 6" stroke="#0098d0" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </button>
    </div>
  </section>
);

export default ResourcesLatestNews; 